// src/utils/notifications.js
// ─── Notification write-helpers ───────────────────────────────────────────────
import {
  collection,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Write a notification for a single, specific user.
 */
export const notifyUser = async ({
  recipientUid,
  type,
  title,
  body,
  link = '/dashboard',
  senderUid = null,
  senderName = null,
  metadata = {},
}) => {
  if (!recipientUid) return;
  try {
    await addDoc(collection(db, 'notifications'), {
      recipientUid,
      type,
      title,
      body,
      link,
      senderUid,
      senderName,
      metadata,
      read: false,
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    console.error('[notifyUser] failed:', err);
  }
};

/**
 * Write ONE broadcast notification visible to all users whose role is in `roles`.
 * Avoids querying the users collection (avoids permission errors for employees).
 *
 * The sender (excludeUid) is tracked in `excludeUids` so their hook filters it out.
 */
export const notifyRoles = async ({
  roles,
  type,
  title,
  body,
  link = '/dashboard/manage',
  excludeUid = null,
  senderUid = null,
  senderName = null,
  metadata = {},
}) => {
  if (!roles?.length) return;
  try {
    await addDoc(collection(db, 'notifications'), {
      recipientRoles: roles,
      excludeUids: excludeUid ? [excludeUid] : [],
      type,
      title,
      body,
      link,
      senderUid,
      senderName,
      metadata,
      readBy: [],          // array — each recipient adds their UID when they read
      createdAt: serverTimestamp(),
    });
  } catch (err) {
    console.error('[notifyRoles] failed:', err);
  }
};
